import Tooltip from "@codegouvfr/react-dsfr/Tooltip";
import React from 'react';
import { FaCircleInfo } from "react-icons/fa6";
import { useCheckFormSchema } from '../hooks/use-check-form-schema.hook';
import { useFormFieldParams } from '../hooks/use-form-field-params.hook';
import { RadioField } from './RadioField';

export const RadioGroupField = ({ name, title, options, onChange, tooltip }: RadioGroupFieldProps) => {
  useCheckFormSchema({ name });

  const { error, isRequired } = useFormFieldParams({ name });

  return (
    <div className={'flex flex-col gap-2'}>

      {(title) && (
        <label className={'flex gap-1'} style={{ color: '#00008F', fontWeight: 'bolder' }} htmlFor={name}>
          {title} {isRequired && <label>*</label>}

          {(tooltip) && (
            <Tooltip title={tooltip!} kind="hover">
              <FaCircleInfo className={'color-primary'} />
            </Tooltip>
          )}
        </label>
      )}

      {error?.message && <span className={'error-message'}>{error?.message}</span>}

      <div className={'flex'}>
        {options.map(({ label, value }, index) => (
          <div key={`${index}-${label}`} className={'flex-1'}>
            <RadioField name={name}
                        title={title}
                        label={label}
                        value={value}
                        onChange={onChange} />
          </div>
        ))}
      </div>
    </div>
  );
};

interface RadioGroupFieldProps {
  options: RadioOption[];
  name: string;
  title: string;
  onChange?: (value: any) => void;
  tooltip?: string;
}

export interface RadioOption {
  label: string;
  value: any;
}